import { Row } from '@busybusy/webapp-react-ui';
import * as React from 'react';

import './Main.scss';

const Main: React.FunctionComponent = ({ children }) => <Row className="main">{children}</Row>;

export default Main;
